import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { ThreadFilterComponent } from './thread-filter.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        DropDownsModule,
        DropDownButtonModule,
        PopupModule,
        DialogsModule,
    ],
    declarations: [
        ThreadFilterComponent,
    ],
    exports: [
        ThreadFilterComponent,
    ],
    providers: []
})
export class ThreadFilterDialogModule {
}
